<template>
  <div class="topbar-container">
        <div class="topbar-left-side">
            <LanguagesMenu />
            <div class="topbar-btn topbar-kinkekaart" :class="{'active': (active == 'kinkekaart')}" @click="openOverlay('kinkekaart')"><Icon name="kinkekaart"></Icon><label data-translation-element="giftcard">Kinkekaart</label></div>
            <div class="topbar-btn topbar-uldinfo" :class="{'active': (active == 'uldinfo')}" @click="openOverlay('uldinfo')"><Icon name="uldinfo"></Icon><label data-translation-element="tab-uldinfo">Üldinfo</label></div>
            <div class="topbar-btn topbar-kategooriad" :class="{'active': (active == 'topics')}" @click="openTopics" v-show="landscape"><Icon name="topics"></Icon><label data-translation-element="tab-categories">Kategooriad</label></div>
        </div>
        <div class="topbar-right-side" v-show="searchbar">
            <div class="search-input" :class="{'active': searchVisible}">
                <Icon name="search" @click="showSearch"/>
                <input class="searchbar" placeholder="Otsi poodi või brändi" oncontextmenu="return false" @click="showSearch" data-translation-attributes="placeholder" data-translation-attribute-placeholder="topbar-search" ref="searchInput"/>
                <div class="icon close" @click="closeSearch"><Icon name="close"/></div>
            </div>
        </div>
  </div>
</template>

<script>
import LanguagesMenu from './LanguagesMenu';
import { mapState } from 'vuex';

export default {
    components: {
		LanguagesMenu,
    },
    props: {
        searchbar: {
            type: Boolean,
            default: true
        },
        active: {
            type: String,
            default: ""
        },
        searchVisible: {
            type: Boolean,
            default: true
        }
    },
    computed: {
		...mapState('wf', ['landscape'])
	},
    methods: {
        showSearch () {
            if (!this.landscape)
                this.$emit('searchinput', this.$refs.searchInput)
            this.$emit('search')
        },
        closeSearch () {
            this.$refs.searchInput.value = '';
            this.$emit('closeSearch')
        },
        openOverlay (name) {
            this.$emit('openOverlay', name);
        },
        openTopics () {
            this.$emit('openTopics');
        }
    }
}
</script>

<style lang="less">
    @import '../css/variables';
    @import '../css/responsive';
    @import '../css/mixins';

    .topbar-container {
        flex-basis: @top-bar-height;
        flex-shrink: 0;
        flex-grow: 0;
        transition: height 0.3s ease-out;
    }

    .topbar-left-side {
        width: 33.5%;
        display: flex;
        align-items: center;
        padding-left: 1.4rem;


        & > * {
            border-right: 0.12rem solid @border-color;
            padding: 2rem;
            font-weight: 500;
        }
    }
    .topbar-right-side {
        flex-grow: 1;
    }
    .topbar-container {
        display: flex;

    }

    .search-input {
        border: 0.1rem solid @border-color;
        background-color: white;
        margin: 0.8rem;
        padding: 0.4rem;
        height: 4.8rem;
        width: auto;
        font-size: 1.8rem;
        font-weight: 500;
        margin: 0.8rem 2.4rem;
        overflow: hidden;
        display: flex;
        align-items: center;

        &.active {
            border: 0.1rem solid @active-color;
            .icon.close {
                opacity: 1;
            }

            .icon-search {
                --color1: @active-color;
            }
        }

        .icon.close {
            opacity: 0;
            margin-right: 2.4rem;
            transition: opacity 0.3s ease-out;
        }

        .icon-search {
            height: 1.8rem;
            margin-left: 2.4rem;
            margin-right: 0.8rem;
            transition: fill 0.3s ease-out;
        }

        input {
            width: 100%;
            height: 100%;
            border: 0;
            font-weight: 500;
            font-size: 1.8rem;
            margin-top: 0.1rem;
            color: @font-color;

            &:focus{
                outline: none;
            }
        }
    }
    .topbar-btn {
        font-size: 1.8rem;
        display: flex;
        align-items: center;
        position: relative;
        flex-grow: 1;
        flex-shrink: 1;
        overflow: hidden;
        height: 6.4rem;

        &::after {
            content: '';
            height: 0;
            transition: height 0.3s ease-out;
            width: 100%;
            position: absolute;
            bottom: 0;
            left: 0;
            background-color: @active-color;
        }

        .icon {
            height: 1.8rem;
            margin-right: 0.4rem;
            transition: --color1 0.3s ease-out;    
        }
        
        &.active .icon {
            --color1: @active-color;
        }

        &.active::after {
            height: 0.8rem;
        }
    }

    @media @portrait {
        .topbar-left-side {
            justify-content: stretch;
        }
    }

    @media @landscape {
        .topbar-container.search-visible {
            flex-basis: 8rem !important;
        }

        .topbar-right-side {
            height: 7.2rem;
            border-top: 0.2rem solid @border-color;

            .search-input {
                margin: 1.2rem 3.6rem;
                z-index: 1;
            }
        }
        .topbar-left-side {
            width: auto;
            height: 8rem;
            flex-basis: 8rem;
            flex-grow: 0;
            flex-shrink: 0;
            padding-left: 0;
            justify-content: space-between;
            flex-direction: row-reverse;
            box-shadow: 3px 16px 7px rgba(0, 0, 0, 0.01), 2px 9px 6px rgba(0, 0, 0, 0.04), 1px 4px 4px rgba(0, 0, 0, 0.07), 0px 1px 2px rgba(0, 0, 0, 0.08), 0px 0px 0px rgba(0, 0, 0, 0.08);
            z-index: 3;
            .up-shadow() !important;

            & > * {
                height: 100%;
                height: 100%;
                flex-grow: 1;
                justify-content: center;

                &:first-child {
                    border-right: none;
                }
            }
        }
    }
</style>